

const DeletePrompt = ({onDelete, onCancel}) => <div className="modal rss-modal fade show" tabindex="-1">
    <div className="modal-dialog">
    <div className="modal-content">
        <div className="modal-body">
            <div className="p-2 text-center">
                <div className="form-group">
                    <label className="form-label text-dark medium">Are you sure you want to delete ?</label>
                    {/* <input type="text" placeholder="" value="https://chirpyweb.com/feed/" className="form-control"/> */}
                </div>
                <div className="text-center">
                    <button className="btn btn-sm  mr-2" onClick={onCancel} >Cancel</button>
                    <button className="btn btn-sm btn-danger" onClick={onDelete} >Delete</button>
                </div>
            </div>                    
        </div>
    </div>
    </div>
</div>


export default DeletePrompt;